export default "__VITE_ASSET__bd96f690__"